// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckConfigQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  checkGroupAndName: Types.Scalars["String"]["input"];
}>;

export type CheckConfigQuery = {
  __typename?: "GraphqlQuery";
  getCheckConfig: {
    __typename?: "CheckConfig";
    id: string;
    enabled: boolean;
    settings: any;
  };
  getServerDetails: { __typename?: "Server"; id: string; name: string };
};

export const CheckConfigDocument = gql`
  query CheckConfig($serverId: ID!, $checkGroupAndName: String!) {
    getCheckConfig(serverId: $serverId, checkGroupAndName: $checkGroupAndName) {
      id
      enabled
      settings
    }
    getServerDetails(serverId: $serverId) {
      id
      name
    }
  }
`;

/**
 * __useCheckConfigQuery__
 *
 * To run a query within a React component, call `useCheckConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckConfigQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      checkGroupAndName: // value for 'checkGroupAndName'
 *   },
 * });
 */
export function useCheckConfigQuery(
  baseOptions: Apollo.QueryHookOptions<
    CheckConfigQuery,
    CheckConfigQueryVariables
  > &
    (
      | { variables: CheckConfigQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CheckConfigQuery, CheckConfigQueryVariables>(
    CheckConfigDocument,
    options,
  );
}
export function useCheckConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckConfigQuery,
    CheckConfigQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CheckConfigQuery, CheckConfigQueryVariables>(
    CheckConfigDocument,
    options,
  );
}
// @ts-ignore
export function useCheckConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckConfigQuery,
    CheckConfigQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<CheckConfigQuery, CheckConfigQueryVariables>;
export function useCheckConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConfigQuery,
        CheckConfigQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckConfigQuery | undefined,
  CheckConfigQueryVariables
>;
export function useCheckConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckConfigQuery,
        CheckConfigQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<CheckConfigQuery, CheckConfigQueryVariables>(
    CheckConfigDocument,
    options,
  );
}
export type CheckConfigQueryHookResult = ReturnType<typeof useCheckConfigQuery>;
export type CheckConfigLazyQueryHookResult = ReturnType<
  typeof useCheckConfigLazyQuery
>;
export type CheckConfigSuspenseQueryHookResult = ReturnType<
  typeof useCheckConfigSuspenseQuery
>;
export type CheckConfigQueryResult = Apollo.QueryResult<
  CheckConfigQuery,
  CheckConfigQueryVariables
>;
